import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { DrawerService } from "mis-design-system/drawer";
import { forkJoin, fromEvent, Observable, Subject } from "rxjs";
import { filter, map, takeUntil } from "rxjs/operators";
import { NsWISConfigurations } from "../../../models/configurations.model";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { BookingDataService } from "../../../services/booking-data.service";
import { ConfigurationService } from "../../../services/configuration.service";
import { HomeDataService } from "../../../services/home-data.service";
import { TeamCalendarService } from "../../../services/team-calendar.service";
import { BookingComponent } from "../../modals/booking/booking.component";

interface IWindowMessage {
  app: string;
  eventType: string;
  value: NsEmpWebExpData.INearbyBooking;
}
@Component({
  selector: "mis-employee-web-exp-calendar",
  templateUrl: "./calendar.component.html",
  styleUrls: ["./calendar.component.scss"]
})
export class CalendarComponent implements OnInit, AfterViewInit, OnDestroy {
  teamCalendarUrl: Observable<string>;
  private endObs = new Subject();
  private configs: NsWISConfigurations.IConfigurations;
  private profile: NsEmpWebExpData.IEmployee;

  constructor(
    private teamCalendarService: TeamCalendarService,
    private drawerSvc: DrawerService,
    private bookingSvc: BookingDataService,
    private configSvc: ConfigurationService,
    private homeData: HomeDataService
  ) {}

  ngOnInit(): void {
    this.teamCalendarService.refreshFrame();
    this.teamCalendarUrl = this.teamCalendarService.url;
    forkJoin([this.configSvc.configurations, this.homeData.employeeInfo])
      .pipe(takeUntil(this.endObs))
      .subscribe(([config, profile]) => {
        this.configs = config;
        this.profile = profile;
      });
  }

  ngOnDestroy(): void {
    this.endObs.next();
    this.endObs.complete();
  }

  ngAfterViewInit(): void {
    const messages = fromEvent(window, "message").pipe(
      takeUntil(this.endObs),
      map(event => (event as MessageEvent<IWindowMessage>).data),
      filter(data => data.app === "TEAM_CALENDAR")
    );
    // nearby booking stream
    messages.pipe(filter(data => data.eventType === "NEAR_BY_BOOKING")).subscribe(data => {
      const configs = this.bookingSvc.setFormForCreate(this.configs, this.profile, "OFFICE", data.value);
      this.drawerSvc.show(BookingComponent, configs, { ...(this.configSvc.isMobile && { width: "100%" }) });
    });
    // create booking stream
    messages.pipe(filter(data => data.eventType === "CREATE_BOOKING")).subscribe(data => {
      const configs = this.bookingSvc.setFormForCreate(this.configs, this.profile, "OFFICE", data.value);
      this.drawerSvc.show(BookingComponent, configs, { ...(this.configSvc.isMobile && { width: "100%" }) });
    });
  }
}
